import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
interface GainCard {
  title: string;
  desc: string;
  imageSrc: string;
  colorClass: string;
}

@Component({
  selector: 'app-gain',
  standalone: true, 
  imports: [CommonModule], 
  templateUrl: './gain.component.html',
  styleUrls: ['./gain.component.scss']
})
export class GainComponent {
  gainCards: GainCard[] = [
    {
      title: 'IndiaAI Certificate',
      desc: 'Earn verified credentials in AI fundamentals, model training, and API workflows',
      imageSrc: 'images/fellowship-cert.svg',
      colorClass: 'pink'
    },
    {
      title: 'Learning Opportunity',
      desc: 'Hands-on workshops covering machine learning, deep learning, and real-world AI applications',
      imageSrc: 'images/hackathon.svg',
      colorClass: 'blue-tint'
    },
    {
      title: 'Engage & Earn Reward',
      desc: 'Participate in challenges, contribute to AI projects, and earn recognition from industry leaders',
      imageSrc: 'images/pathways.svg',
      colorClass: 'magenta'
    },
    {
      title: 'Start Your Journey with IndiaAI Ecosystem',
      desc: "Connect with AI startups, researchers, investors, and policymakers shaping India's AI future",
      imageSrc: 'images/open-source.svg',
      colorClass: 'orange'
    },
    {
      title: 'Explore Fellowships',
      desc: 'Apply for prestigious AI fellowships with mentorship, research funding, and real-world impact opportunities',
      imageSrc: 'images/portfolio.svg',
      colorClass: 'teal'
    },
    {
      title: 'Explore Compute Notebook',
      desc: 'Access cloud compute, collaborate on open-source AI projects, and build your AI portfolio',
      imageSrc: 'images/networking.svg',
      colorClass: 'violet'
    }
  ];


}
